import { IndustryConfig } from '../../../types'

export const transportationLogisticsConfig: IndustryConfig = {
  id: 'transportation-logistics',
  name: 'Transportation & Logistics',
  icon: '���',
  description: 'Freight, shipping, and logistics service providers',
  
  businessTypes: [
    {
      id: 'trucking-company',
      name: 'Trucking Company',
      description: 'Over-the-road and local freight transport'
    },
    {
      id: 'logistics-provider',
      name: 'Logistics Provider',
      description: '3PL and supply chain management services'
    }
  ],
  
  revenueStreamTypes: [
    {
      id: 'freight-revenue',
      name: 'Freight Revenue',
      description: 'Transportation and shipping service revenue',
      intelligenceValue: "We'll monitor freight rates and capacity utilization trends."
    }
  ],
  
  supplierCategories: [
    {
      id: 'vehicle-suppliers',
      name: 'Vehicle Suppliers',
      suppliers: ['Freightliner', 'Peterbilt', 'Kenworth', 'Volvo Trucks'],
      spendRanges: ['Under $100K', '$100K-$500K', '$500K-$2M', 'Over $2M']
    }
  ],
  
  competitiveFactors: [
    'Route coverage',
    'On-time performance',
    'Competitive pricing',
    'Technology capabilities'
  ]
}
